<script setup lang="ts">
import { runCommand } from '@/commands/registry'
import { ref } from 'vue'
import { useDocumentStore } from '@/stores/documentStore'
import { useModal } from '@/composables/useModalStack'
import { useI18n, type I18nKey } from '@/i18n'

const props = defineProps<{ kind: 'feather' | 'expand' | 'contract' | 'border' }>()
const emit = defineEmits<{ close: [] }>()
useModal('selection-modify')
const { t } = useI18n()
const docStore = useDocumentStore()
const amount = ref(props.kind === 'feather' ? 2 : props.kind === 'border' ? 4 : 1)
function run() {
  if (!(amount.value > 0)) return
  void runCommand('selection.modify', { kind: props.kind, amount: amount.value })
  emit('close')
}
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')" @keydown.enter="run">
      <h2>{{ t(`dialog.modify.${kind}` as I18nKey) }}</h2>
      <label class="field"><span>{{ t('dialog.modify.amount') }}</span><input v-model.number="amount" type="number" min="0.1" max="500" step="1" autofocus /></label>
      <div class="actions">
        <button @click="emit('close')">{{ t('dialog.cancel') }}</button>
        <button class="primary" @click="run">{{ t('dialog.ok') }}</button>
      </div>
    </div>
  </div>
</template>
